<template>
  <div class="gallery-container">
    <!-- Fullscreen Modal -->
    <div v-if="showModal" id="galleryModal" class="gallery-modal">
      <span class="close-modal" @click="closeModal">&times;</span>
      <swiper-container
        class="fullscreen-swiper"
        :slides-per-view="1"
        navigation
        ref="galleryTop"
      >
        <swiper-slide v-for="(image, index) in mainImages" :key="index" lazy>
          <img :src="image.big" alt="Gallery Image" />
        </swiper-slide>

        <!-- VR iframe -->
        <swiper-slide v-if="vrUrl">
          <iframe
            :src="vrUrl"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </swiper-slide>

        <!-- Navigation -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </swiper-container>
    </div>

    <!-- Main Gallery -->
    <swiper-container
      class="main-swiper"
      :slides-per-view="1"
      navigation
      pagination
      pagination-type="fraction"
      thumbs-swiper=".thumb-swiper"
      ref="mainSwiper"
      centered-slides
    >
      <swiper-slide v-for="(image, index) in mainImages" :key="index" lazy>
      <img :src="image.image" alt="Image description" class="main-image" @click="openModal"/>
      </swiper-slide>

      <!-- VR iframe -->
      <swiper-slide v-if="vrUrl" class="main-vr" >
        <iframe
          :src="vrUrl"
          width="100%"
          height="100%"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </swiper-slide>
    </swiper-container>

    <!-- Thumbnail Swiper -->
     <div class="thumb-wrapper">
       <swiper-container
         class="thumb-swiper"
         space-between="10"
         loop="false"
         free-mode
         watch-slides-progress
         ref="thumbSwiper"
         slides-per-view="auto"
       >
         <swiper-slide v-for="(image, index) in mainImages" :key="index" lazy>
           <img :src="image.thumb" alt="Thumbnail" class="thumbnail-image" />
         </swiper-slide>
   
         <!-- VR Thumbnail -->
         <swiper-slide v-if="vrUrl" lazy>
           <img
             src="../../assets/view-360.png"
             alt="Thumbnail"
             class="thumbnail-image"
           />
         </swiper-slide>
       </swiper-container>
     </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  props: {
    mainImages: {
      type: Array,
      required: true,
    },
    vrUrl: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const showModal = ref(false);
    const mainSwiper = ref(null);
    const thumbSwiper = ref(null);
    const galleryTop = ref(null);

    const openModal = () => {
      showModal.value = true;

      // Sync the galleryTop Swiper with the active slide in the mainSwiper
      const currentSlideIndex = mainSwiper.value.swiper.realIndex;
      setTimeout(() => {
        galleryTop.value.swiper.slideTo(currentSlideIndex);
        galleryTop.value.swiper.update();
      }, 200);
    };

    const closeModal = () => {
      showModal.value = false;
    };

    onMounted(() => {
      // Sync the main and thumb swipers
      const swiperInstance = mainSwiper.value.swiper;
      const thumbInstance = thumbSwiper.value.swiper;

      // Connect thumbnails with main swiper
      swiperInstance.thumbs.swiper = thumbInstance;
      swiperInstance.thumbs.init();
    });

    return {
      showModal,
      openModal,
      closeModal,
      mainSwiper,
      thumbSwiper,
      galleryTop,
    };
  },
};
</script>

<style lang="scss" scoped>
.gallery-container {
  width: 100%;
  height: 100%;
  padding: 5px 15px 15px 15px;
}

swiper-container {
  width: 100%;
  height: 100%;
}

swiper-slide {
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

swiper-slide {
  background-size: cover;
  background-position: center;
}

/* Main */
.main-swiper {
  width: 100%;
  padding-top: 5px;
}

.main-swiper swiper-slide img {
  height: 600px;
  object-fit: contain;
  overflow: hidden;
}

.main-vr {
  height: 600px;
}


/* Thumb */
.thumb-swiper {
  height: 70px;
  margin-top: 15px;
}

.thumb-wrapper {
  width: 100%;
}

.thumb-swiper swiper-slide {
  width: 110px;
  height: 70px;
  opacity: 0.4;
}

.thumb-swiper .swiper-slide-thumb-active {
  opacity: 1;
}

.thumb-swiper swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


/* Fullscreen Modal */
.gallery-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.close-modal {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 36px;
  color: white;
  cursor: pointer;
}

.fullscreen-swiper {
  width: 90%;
  height: 90%;
}

.fullscreen-swiper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}




// Media 

@media (max-width: 991px) {
  .main-swiper swiper-slide, .main-swiper swiper-slide img {
    height: 300px;
  }

  
}

@media (max-width: 400px) {
  .gallery-container {
      padding: 5px 0 15px 0 !important;
  }
}


</style>
